import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import ImageLoader from '../../common/ImageLoader/ImageLoader';


const BlogItem = ({ image, title, excerpt, date, slug }) => {
  const months = ['Január', 'Február', 'Március', 'Április', 'Május', 'Június', 'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'];
  const dateObject = new Date(date);
  const dateString = `${months[dateObject.getMonth()]} ${dateObject.getDate()}.`;

  return (
    <div className="blog-item">
      <ImageLoader src={image.medium_large || image.full} alt={title} className="blog-item__image" />
      <Link to={`/blog/${slug}`} className="blog-item__content">
        <h4 className="blog-item__title">{ReactHtmlParser(title)}</h4>
        <div className="blog-item__date">
          {dateString}
        </div>
        <div className="blog-item__excerpt">{ReactHtmlParser(excerpt.replace(' [&hellip;]', '...'))}</div>
      </Link>
      <Link to={`/blog/${slug}`} className="blog-item__more-btn">
        <i className="fas fa-angle-right"></i>
      </Link>
    </div>
  );
};


BlogItem.propTypes = {
  image: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired
};

export default BlogItem;



// WEBPACK FOOTER //
// ./src/components/Home/Blog/BlogItem.js